const moonPhaseEntities = [
  '🌕',   // full
  '🌖',   // waning gibbous
  '🌗',   // last qtr
  '🌘',   // waning crescent
  '🌑',   // new
  '🌒',   // waxing cresent
  '🌓',   // first qtr
  '🌔',   // waxing gibbous
];

const OC_TREF_0HUT_MJD = 51564.0;
const OC_SYNODIC_PERIOD = 29.53058867;

export const approximateMoonPhase = (mjd) => {
  const phase8 = ((mjd - OC_TREF_0HUT_MJD) % OC_SYNODIC_PERIOD) / OC_SYNODIC_PERIOD * 8;
  let sel = Math.floor(phase8 + 0.5);
  if (sel >= 8){
    sel = 0;
  }

  return moonPhaseEntities[sel];
};